import { render } from "./VectorAltliklariButtonSvg.vue?vue&type=template&id=d037a878"
import script from "./VectorAltliklariButtonSvg.vue?vue&type=script&lang=js"
export * from "./VectorAltliklariButtonSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__